module.exports = __webpack_public_path__ + "img/plus.8188a9e8.svg";